import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operativeStatePipe'
})
export class OperativeStatePipe implements PipeTransform {

  transform(value: string): string {
    const operativeStateIcon = value.toLowerCase() === 'available' ? '<i class="fa fa-check-circle" title="Available"></i>' :
      `<i class="fa fa-times-circle" title="${value.toLowerCase() === 'predeleted' ? 'Pre-deleted' : 'Unavailable'}"></i>`;

    return `<div class="center-content">${operativeStateIcon}</div>`;
  }

}
